import direct from "./Images/direct.png";
import upDownDark from "./Images/upDownDark.png";
import upDownLight from "./Images/upDownLight.png";
export const Images = {
  direct: direct,
  upDownDark: upDownDark,
  upDownLight: upDownLight,
};
